import buildLocalizeFn from '../../../_lib/buildLocalizeFn/index';

function ordinalNumber(dirtyNumber, dirtyOptions) {
  const number = Number(dirtyNumber);

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'aad';
      case 2:
        return number + 'aad';
      case 3:
        return number + 'aad';
    }
  }
  return number + 'th';
}

const eraValues = {
  narrow: ['A', 'B'],
  abbreviated: ['AD', 'BC'],
  wide: ['Anno Domini', 'Ciise Horteed'],
};

const quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Rubuca1', 'Rubuca2', 'Rubuca3', 'Rubuca4'],
  wide: ['Rubuca 1aad', 'Rubuca 2aad', 'Rubuca 3aad', 'Rubuca 4aad'],
};

const monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'O', 'S', 'O', 'N', 'D'],
  abbreviated: [
    'Jan',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ogo',
    'Seb',
    'Okt',
    'Nof',
    'Dis',
  ],
  wide: [
    'Janaayo',
    'Febraayo',
    'Maarso',
    'Abriil',
    'Maayo',
    'Juun',
    'Juulay',
    'Ogosto',
    'Sebtambar',
    'Oktoobar',
    'Noofambar',
    'Diisambar',
  ],
};

const dayValues = {
  narrow: ['A', 'I', 'S', 'A', 'Kh', 'J', 'S'],
  short: ['Ax', 'Is', 'Sa', 'Ar', 'Kh', 'Ji', 'Sa'],
  abbreviated: ['Axd', 'Isn', 'Sal', 'Arb', 'Kha', 'Jim', 'Sab'],
  wide: ['Axad', 'Isniin', 'Salaasa', 'Arbaca', 'Khamiis', 'Jimce', 'Sabti'],
};

const dayPeriodValues = {
  narrow: {
    am: 'subaxnimo',
    pm: 'galabnimo',
    midnight: 'saq badhka',
    noon: 'duhur',
    morning: 'Subax',
    afternoon: 'Galab',
    evening: 'Fiidka',
    night: 'habeen',
  },
  abbreviated: {
    am: 'Subaxnimo',
    pm: 'Galabnimo',
    midnight: 'saq badhkii',
    noon: 'duhur',
    morning: 'Subax',
    afternoon: 'Galab',
    evening: 'Fiidka',
    night: 'habeen',
  },
  wide: {
    am: 'subaxdii',
    pm: 'gelinka dambe',
    midnight: 'saq badhkii',
    noon: 'duhur',
    morning: 'Subax',
    afternoon: 'Galab',
    evening: 'Fiidka',
    night: 'habeen',
  },
};

const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide',
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    },
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
  }),
};

export default localize;
